import { useState } from 'react';
import { Heading, LinkButton, Stack } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
import { DangerousHtmlContent, Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { AnimatePresence, m as motion } from 'framer-motion';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const chevronIconStyles = isExpanded => css`
  margin-top: 2px;
  transform: rotateX(${isExpanded ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
`;
const linkStyles = css`
  align-items: center;
  display: flex;
  font-size: 0.875rem;
  gap: 6px;
`;
const headingStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.825rem;
  font-weight: 700;
`;
const linkButtonMotionVariants = {
  enter: {
    overflow: 'hidden',
    height: 'auto',
    transition: {
      type: 'tween',
      duration: 0.2
    }
  },
  exit: {
    height: 0,
    transition: {
      type: 'tween',
      duration: 0.15
    }
  }
};
const ReadMoreContent = _ref => {
  let {
    dataTestId,
    description,
    dimensions,
    name,
    readMoreText,
    termsUrl,
    piecesAndWeight
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const handleClick = () => {
    setShowMore(state => !state);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    "data-testid": dataTestId,
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Heading, {
      className: headingStyles,
      level: 2,
      children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
        content: name
      })
    }), /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: description
    }), piecesAndWeight && /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: piecesAndWeight
    }), dimensions && /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: dimensions
    }), /*#__PURE__*/_jsx(AnimatePresence, {
      initial: false,
      children: showMore && /*#__PURE__*/_jsxs(motion.div, {
        animate: "enter",
        exit: "exit",
        initial: "exit",
        variants: linkButtonMotionVariants,
        children: [/*#__PURE__*/_jsx(DangerousHtmlContent, {
          content: readMoreText
        }), termsUrl && /*#__PURE__*/_jsx("a", {
          href: termsUrl,
          rel: "noreferrer",
          target: "_blank",
          children: t('coverGeniusPolicyLinkText')
        })]
      })
    }), readMoreText && !piecesAndWeight && /*#__PURE__*/_jsxs(LinkButton, {
      className: linkStyles,
      "data-testid": "readMore-button",
      onClick: handleClick,
      children: [!showMore ? t('Products.ReadMore.Link.Label') : t('Products.ReadLess.Link.Label'), /*#__PURE__*/_jsx(Icon, {
        className: chevronIconStyles(showMore),
        color: "currentColor",
        id: "chevron-down",
        size: "0.6875rem"
      })]
    }), termsUrl && !readMoreText && /*#__PURE__*/_jsx("a", {
      href: termsUrl,
      rel: "noreferrer",
      target: "_blank",
      children: t('coverGeniusPolicyLinkText')
    })]
  });
};
export default ReadMoreContent;
//# sourceMappingURL=ProductReadMoreContent.js.map